<template>
  <div>
    <div class="action">
      <div class="btn-container">
        <small
          class="text-danger mr-3"
          v-if="saveComponentState.error">
          {{saveComponentState.error}}
        </small>
        <small
          class="text-success font-weight-bold mr-3"
          v-if="saveComponentState.isSaved">
          <i class="fa fa-check" /> บันทึกแล้ว
        </small>
        <button
          type="button"
          class="btn btn-primary"
          @click="saveComponent">
          บันทึก
        </button>
        <Dropdown
          alignment="right">
          <template v-slot:dropdow-button>
            <button
              type="button"
              class="btn btn-outline-dark btn-action m-0 ml-2">
              <i class="fas fa-cog"></i>
            </button>
          </template>
          <div
            class="dropdown-item"
            @click.stop="changeTitle">
            {{ dropDownText }}
          </div>
        </Dropdown>
      </div>
    </div>
    <ChangeTitleModal
      v-if="showChangeTitleModal"
      :title.sync="component.name"
      :showChangeTitleModal.sync="showChangeTitleModal"/>
    <SliderEditor
      class="slider-editor"
      v-if="isSliderComponent()"
      :sliderName.sync="component.name"
      :data.sync="component.data"/>
    <BannerEditor
      ref="bannerEditor"
      class="banner-editor"
      v-if="isBannerComponent()"
      :bannerName.sync="component.name"
      :data.sync="component.data"/>
    <PopupEditor
      ref="popup-editor"
      class="popup-editor"
      v-if="isPopupComponent()"
      :popupName.sync="component.name"
      :data.sync="component.data"/>
  </div>
  <!-- if component.type === 'banner' do something -->
</template>

<script>
// Systems
import _ from 'lodash';
import Dropdown from '@/components/Dropdown.vue';

// Scoped
import PopupEditor from './popup/PopupEditor.vue';
import SliderEditor from './slider/SliderEditor.vue';
import BannerEditor from './banner/BannerEditor.vue';
import ChangeTitleModal from './ChangeTitleModal.vue';

// APIs
import { updateComponentById } from './api';

export default {
  props: {
    componentData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      component: null,
      saveComponentState: {
        isSaving: false,
        isSaved: false,
        error: false,
      },
      showChangeTitleModal: false,
    };
  },
  components: {
    SliderEditor,
    BannerEditor,
    PopupEditor,
    Dropdown,
    ChangeTitleModal,
  },
  computed: {
    pageDesignerKey() {
      return this.$route.params.pageDesignerKey;
    },
    pageComponentKey() {
      return this.$route.params.pageComponentKey;
    },
    dropDownText() {
      if (this.isSliderComponent()) return 'เปลี่ยนชื่อสไลเดอร์';
      if (this.isBannerComponent()) return 'เปลี่ยนชื่อแบนเนอร์';
      if (this.isPopupComponent()) return 'เปลี่ยนชื่อป๊อปอัพ';
      return '';
    },
  },
  created() {
    this.component = _.cloneDeep(this.componentData);
  },
  methods: {
    isSliderComponent() {
      return this.component && this.component.type === 'slider';
    },
    isBannerComponent() {
      return this.component && this.component.type === 'banner';
    },
    isPopupComponent() {
      return this.component && this.component.type === 'popup';
    },
    async saveComponent() {
      this.saveComponentState.isSaving = true;
      if (this.isBannerComponent()) {
        this.$refs.bannerEditor.reSort();
      }
      try {
        const dKey = this.pageDesignerKey;
        const cKey = this.pageComponentKey;
        const payload = {
          name: this.component.name,
          data: this.component.data,
        };
        await updateComponentById(dKey, cKey, payload);
        this.saveComponentState.isSaved = true;
        setTimeout(() => {
          this.saveComponentState.isSaved = false;
        }, 2000);
      } catch (error) {
        this.saveComponentState.error = error;
      }
      this.saveComponentState.isSaving = false;
    },
    changeTitle() {
      this.showChangeTitleModal = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.action {
  position: absolute;
  right: 10px;
  top: 22px;
}
.slider-editor, .banner-editor, .popup-editor {
  width: calc(100vw - 260px);
  margin: auto;
  overflow: hidden;
  min-height: 100vh;
  max-height: 100vh;
}

.btn-container {
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;
  .dropdown {
    margin-left: 4px;
  }
}

@media screen and (max-width: 991.98px) {
  .slider-editor {
    width: 100vw;
  }
}

@media screen and (max-width: 768px) {
  .slider-editor, .banner-editor, .popup-editor {
    width: 96vw;
    overflow-x: hidden;
    overflow-y: scroll;
    min-height: unset;
    max-height: unset;
  }
}
</style>
